export default {
  API_BASE: 'https://foradev.vegayazilim.com.tr',
  //API_BASE: 'http://127.0.0.1:8080',
}
